import ExaminationQuestionList from './ExaminationQuestionList';

export default ExaminationQuestionList;
